export default __webpack_public_path__ + "static/button-action-dont-light-95de64823152eb2f8dcbfd01e98d836e.png";